import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardDevice } from '@vi-iot/client';

@Pipe({
  name: 'dashboardOperatingMode',
  standalone: true,
})
export class DashboardOperatingModePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  // check if operating mode has any keyword or dhw itself has any mode different than off
  transform(device: DashboardDevice): string {
    let heatingLabel: string;
    let coolingLabel: string;
    let dhwLabel: string;

    if (!device?.heatingOperatingModes?.length) {
      return null;
    }

    device.heatingOperatingModes.forEach((operatingMode) => {
      const modeToCompare = operatingMode.mode.toLocaleLowerCase();
      if (modeToCompare.includes('heating')) {
        heatingLabel = this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.OPERATING_MODE.HEATING'
        );
      }
      if (modeToCompare.includes('cooling')) {
        coolingLabel = this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.OPERATING_MODE.COOLING'
        );
      }

      const isDhwOperatingModeActive =
        !!device.dhwOperatingMode && device.dhwOperatingMode !== 'off';
      if (modeToCompare.includes('dhw') || isDhwOperatingModeActive) {
        dhwLabel = this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.OPERATING_MODE.DHW'
        );
      }
    });

    const outputLabel = [heatingLabel, coolingLabel, dhwLabel].filter((label) => label).join(' & ');

    return outputLabel;
  }
}
